import { useLocale } from 'react-aria';

export function useIsRTL() {
  const { direction } = useLocale();
  return direction === 'rtl';
}
